// src/components/ui/Hero.jsx
import React from "react";

/** Big blue banner with title, subtitle and optional right-side content */
export default function Hero({ title, subtitle, right = null, className = "" }) {
  return (
    <div className={`mt-2 ${className}`}>
      <div className="bg-sky-400 text-white rounded-2xl px-4 py-5 sm:px-6 sm:py-6
                      flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
        <div className="min-w-0">
          <h1 className="text-2xl sm:text-3xl font-extrabold leading-tight">{title}</h1>
          {subtitle ? <p className="text-white/90 mt-2 text-sm sm:text-base">{subtitle}</p> : null}
        </div>
        {right ? <div className="flex items-center gap-2">{right}</div> : null}
      </div>
    </div>
  );
}
